import React, { useEffect, useState } from 'react';
import '../css/Banner.css';
const images = [
    `${process.env.PUBLIC_URL}/image1.jpg`,
    `${process.env.PUBLIC_URL}/image2.jpg`,
    `${process.env.PUBLIC_URL}/image3.jpg`,
];

const VideoBanner: React.FC = () => {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        setIsVisible(true);
    }, []);

    return (
        <div className="banner">
            <div
                className="image-container"
                style={{
                    backgroundImage: `url(${process.env.PUBLIC_URL + '/banner2.png'})`,
                    backgroundColor: `rgba(0, 0, 0, 0.5)`,
                    backgroundBlendMode: 'multiply',
                    backgroundSize: 'cover',
                    backgroundRepeat: 'no-repeat',
                    backgroundOrigin: 'border-box',
                    backgroundPosition: 'center',
                    overflow: 'hidden',
                }}
            ></div>
            <div
                className={`banner-cover ${isVisible ? 'visible' : ''}`}
                style={{
                    backgroundImage: `url(${process.env.PUBLIC_URL + '/banner1.png'})`,
                    backgroundColor: `rgba(0, 0, 0, 0.5)`,
                    backgroundBlendMode: 'multiply',
                    backgroundSize: 'cover',
                    backgroundRepeat: 'no-repeat',
                    backgroundOrigin: 'border-box',
                    backgroundPosition: 'center',
                    overflow: 'hidden',
                }}
            >
                <div className="banner-title">
                    <div>
                        <div className="banner-title-eng">Academy Business Description</div>
                        <div className="banner-title-kor">외환 트레이딩 동반자</div>
                    </div>
                </div>
                <div className="banner-corpname">───골든크로스</div>
            </div>
        </div>
    );
};

export default VideoBanner;
